import React from 'react';
import SalelaryLandingPage from "./components/SalelaryLandingPage";

function App() { 
    return <SalelaryLandingPage />;

}

export default App;
